<template>
<div class="modal" :data-active="active">
  <div class="modal__content">

    <!-- ボディー -->
    <div class="modal__body">
      <slot name="content"></slot>
    </div>

    <!-- フッター -->
    <div class="modal__footer" v-if="showfooter">
      <div class="footer" @click="closeDialog">
        <div class="modallink" data-color="black_in_white" v-if="showclose">
          <span>閉じる</span>
        </div>
        <div class="modallink" data-color="white_in_black" @click="closeDialog">
          <a :href="showclose==true ? '/2019_luck' : null ">
            <span>{{msg}}</span>
          </a>
        </div>
      </div>
    </div>

  </div>

  <div class="modal__backdrop" @click="closeDialog"></div>
</div>
</template>

<script>
export default {
  name: 'app-modal-image',
  data() {
    return {
      msg: 'チェック'
    }
  },
  props: {
    active: { type: Boolean, default: false },
    close: { type: Boolean, default: false},
    showfooter: { type: Boolean, default: false },
    showclose: { type: Boolean, default: true }
  },
  beforeMount() {
    const pathname = window.location.pathname
    if(pathname === '/2019_luck'){
      this.msg = 'さっそくチェック'
    }
    return this.msg
  },
  methods: {
    closeDialog() {
      gtag('set', 'page_location', this.locationPath);
      this.$emit('close')
    }
  },
  watch: {
    active() {
      document.body.dataset.visibleDialog = this.active
    }
  }
}</script>

<style lang="scss">
body {
  &[data-visible-dialog="false"] { }
  &[data-visible-dialog="true"] { overflow: hidden; }
}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppModalImage.vue